// Copyright (c) 2016 Deere & Company

import Criteria, {getDefaultState} from '../../delivery-no-documents/state/criteria';
import actions from '../../actions-list';

const updateDaysFromRegistrationCriteria = (state, action) =>
    Criteria.update(state, {
        daysFromRegistration: {
            $set: action.daysFromRegistration
        }
    });

const resetDaysFromRegistrationCriteria = state =>
    Criteria.update(state, {
        daysFromRegistration: {
            $set: null
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_DELIVERY_NO_DOCUMENTS_DAYS_CRITERIA]: updateDaysFromRegistrationCriteria,
        [actions.RESET_DELIVERY_NO_DOCUMENTS_DAYS_CRITERIA]: resetDaysFromRegistrationCriteria
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/delivery-no-documents/reducers/criteria.js